import { GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST, GET_GRAY_JOB_RECEIVE_RETURN_TRANSACTIONS_TAKA_NO, GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST_FAILURE,
  GET_GRAY_JOB_RECEIVE_RETURN_TRANSACTIONS, GET_GRAY_JOB_RECEIVE_RETURN_AVAILABLE_TRANSACTIONS } from '../types';

const initialState = {
  transactions: [],
  availableTransactions: [],
  takaNos: [],
  loading: false,
  error: null,
};

const grayJobReceiveReturnTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_GRAY_JOB_RECEIVE_RETURN_TRANSACTIONS: {
      return {
        ...state,
        transactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_GRAY_JOB_RECEIVE_RETURN_TRANSACTIONS_TAKA_NO: {
      return {
        ...state,
        takaNos: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_GRAY_JOB_RECEIVE_RETURN_AVAILABLE_TRANSACTIONS: {
      return {
        ...state,
        availableTransactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default grayJobReceiveReturnTransactionReducer;
